module.exports = __webpack_public_path__ + "media/images/hero/glyph-d2-1d7a72c26d86587a56d975059a8bee95.svg";